import { makeStyles } from "@material-ui/core";
import { format, parseJSON } from "date-fns";
import React from "react";
import { useTranslation } from "react-i18next";
import { KvixIcon } from "../../icons";
import { Text } from "../../Primitives";
const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        alignItems: "center"
    },
    timeWrapper: {
        fontSize: 12,
        lineHeight: 1,
        textDecoration: (props) => (props.isCancelled ? "line-through" : "none"),
        color: "#ff0000",
        fontWeight: theme.palette.type === "dark" ? 600 : 700,
        backgroundColor: theme.palette.type === "dark" ? theme.palette.background.paper : "#eee",
        borderRadius: 4,
        padding: "3px 4px 4px 4px"
    },
    time: {
        color: theme.palette.type === "dark" ? theme.palette.text.hint : "#444"
    },
    arrow: {
        fontSize: 12
    },
    cancelled: {
        fontSize: 12,
        lineHeight: 1,
        textTransform: "uppercase",
        fontWeight: 700,
        marginLeft: 5,
        transform: "translateY(-0.05em)"
    },
    done: {
        fontSize: 12,
        marginLeft: 5
    },
    liveIndicator: {
        backgroundColor: theme.palette.type === "dark" ? "#eee" : "#444",
        color: theme.palette.type === "dark" ? "#444" : "#eee",
        textTransform: "uppercase",
        fontSize: 12,
        lineHeight: 1,
        fontWeight: theme.palette.type === "dark" ? 600 : 700,
        borderRadius: 4,
        padding: "3px 4px 4px 4px",
        "&:before": {
            content: "''",
            display: (props) => (props.in ? "none" : "inline-block"),
            width: ".325em",
            height: ".325em",
            marginRight: ".15em",
            borderRadius: "50%",
            backgroundColor: "currentColor",
            transform: "translateY(-0.2125em)",
            animation: "3s $flash",
            animationDelay: "500ms",
            animationIterationCount: "infinite",
            animationTimingFunction: "ease-in-out"
        }
    }
}));
export const TimeRangeIndicator = (props) => {
    const classes = useStyles(props);
    const { t, ready } = useTranslation("general");
    const startTime = format(parseJSON(props.start), "HH:mm");
    const endTime = format(parseJSON(props.end), "HH:mm");
    if (!ready) {
        return null;
    }
    return (React.createElement(Text, { className: classes.root }, props.isLive ? (React.createElement("span", { className: classes.liveIndicator }, t("liveIndicator.live"))) : (React.createElement(React.Fragment, null,
        React.createElement("span", { className: classes.timeWrapper },
            React.createElement("span", { className: classes.time }, startTime)),
        React.createElement(KvixIcon.Arrow.Forward, { className: classes.arrow }),
        React.createElement("span", { className: classes.timeWrapper },
            React.createElement("span", { className: classes.time }, endTime)),
        props.isCancelled ? (React.createElement("span", { className: classes.cancelled }, t("buttons.cancelled"))) : props.isFinished ? (React.createElement(KvixIcon.Done, { className: classes.done })) : ("")))));
};
//# sourceMappingURL=TimeRangeIndicator.js.map